import React from 'react';
import './delat.css';

/**
 * Instruktionens kapitel. Det kapitel man läser markeras utifrån aktuell sida.
 * @param {{ kapitel: Array<{rubrik: string, sida: number|null}>, sida: number, onValj: (sida: number|null, kapitel: object) => void, rubrik?: string }} props
 */
export default function KapitelLista({ kapitel = [], sida = 1, onValj, rubrik = 'Kapitel', visaSidnummer = true }) {
  let aktivt = -1;
  kapitel.forEach((k, i) => { if (k.sida && k.sida <= sida) aktivt = i; });
  return (
    <nav className="instr-kapitel" aria-label="Kapitel">
      <div className="instr-kapitel-rubrik">
        <span>{rubrik}</span>
        {visaSidnummer && <span>Sida</span>}
      </div>
      {kapitel.map((k, i) => (
        <button
          key={`${i}-${k.rubrik}`}
          type="button"
          className={`instr-kapitel-rad${i === aktivt ? ' aktiv' : ''}`}
          onClick={() => onValj(k.sida, k)}
          aria-current={i === aktivt ? 'true' : undefined}
        >
          <span className="nr">{i + 1}</span>
          <span>{k.rubrik}</span>
          {visaSidnummer && <span className="sid">{k.sida || ''}</span>}
        </button>
      ))}
    </nav>
  );
}
